import { TOptions } from 'i18next';
import { i18n } from 'next-i18next';

export type StringMap<T = unknown> = { [key: string]: T };

export const t = (
  key: string,
  optionsOne?: string | TOptions<StringMap>,
  optionsTwo?: string | TOptions<StringMap>,
): string => {
  if (i18n) {
    if (optionsTwo) {
      return i18n?.t(key, {
        defaultValue: optionsOne as string,
        ...(typeof optionsTwo === 'object' ? optionsTwo : {}),
      });
    }
    return i18n?.t(key, optionsOne as TOptions<StringMap>);
  }
  if (typeof optionsOne === 'string') {
    return optionsOne;
  }
  return (optionsOne?.defaultValue as string) || '';
};
